<template>
  <section style="overflow-x: hidden; padding-bottom: 100px">
    <!-- Intro Section -->
    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
          <h1
            class="page-title text-gradient"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
          >
            Become a Sponsor
          </h1>
        </div>
      </div>
    </div>

    <!-- Sponsor Content -->
    <div class="container">
      <div class="row">
        <div
          class="col-10 offset-1 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2 text-left"
        >
          <h6
            class="about-sub-heading my-5"
            data-aos="fade-up"
            data-aos-once="true"
          >
            Partner with the Leicester Caribbean Carnival – Celebrate Culture,
            Elevate Your Brand
          </h6>

          <div class="about-text" data-aos="fade-up">
            <p>
              Join us for a landmark celebration as the Leicester Caribbean
              Carnival marks 41 years of music, dance, food, and vibrant
              cultural expression. With up to 100,000 attendees expected at
              Victoria Park on Saturday 1st August 2026, this is your chance to
              align your brand with one of the UK’s most iconic community
              events.
            </p>

            <p>
              Whether you're a multinational, a local business, or a community
              group, we offer a range of sponsorship packages from headline
              partners to bespoke opportunities that deliver exceptional value,
              visibility, and community impact.
            </p>

            <h6>Why Sponsor Leicester Caribbean Carnival?</h6>
            <ul>
              <li>
                <strong>Unrivalled Brand Exposure:</strong> Be seen by over
                100,000 attendees with extensive media coverage across Leicester
                and beyond.
              </li>
              <li>
                <strong>Cultural & Community Impact:</strong> Support an event
                that champions diversity, inclusion, and social unity.
              </li>
              <li>
                <strong>Marketing Power:</strong> Amplify your brand with logo
                placement, social media campaigns, press coverage, and onsite
                activation.
              </li>
              <li>
                <strong>Corporate Social Responsibility:</strong> Demonstrate
                your commitment to community enrichment and cultural
                celebration.
              </li>
              <li>
                <strong>Bespoke Opportunities:</strong> No contribution is too
                small – we’ll work with you to design a sponsorship package
                tailored to your goals and budget.
              </li>
            </ul>

            <p>
              From sponsoring a stage or parade float, to supporting our
              volunteers or digital promotions, we can create a partnership that
              suits your brand’s unique voice and values.
            </p>

            <h6>Sponsorship Starts at Just £500</h6>
            <p>
              From our Bronze and Silver packages to Gold headline sponsorship,
              every tier offers meaningful benefits. We also welcome Community
              Partners and custom collaborations.
            </p>

            <p><strong>Let’s create something unforgettable.</strong></p>

            <p><strong>📧:</strong> promotions@leicestercarnival.co.uk</p>
            <p><strong>📞:</strong> 0116 2211793</p>

            <b-button
              class="btn-carnival bg-yellow text-blue font-weight-bold mt-3"
              @click="downloadSponsorshipPack"
            >
              Download the Full Sponsorship Pack (PDF)
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    downloadSponsorshipPack() {
      window.open('/sponsorship-pack.pdf', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.about-sub-heading {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.69;
  letter-spacing: -0.2px;
  color: #565887;
}

.about-text {
  font-size: 15px;
  line-height: 1.8;
  color: #565887;
  margin-bottom: 1.5rem;
  text-align: left;
}

.btn-carnival {
  padding: 0.5rem 1.5rem;
  font-size: 16px;
  border-radius: 6px;
}
</style>
